export default __webpack_public_path__ + "static/SegoeUI-SemiBold-d3ebb785eab2e77c2144464c53177d7a.ttf";